import React from 'react'
import InboxPromo from '../../../../assets/images/promo-inbox.png'
import './InboxUpsell.scss'

export const InboxUpsellBody: React.FC = () => {
  return (
    <>
      <a href='https://youtu.be/0vF8GGSg3Bk' target='_blank' rel='noopener noreferrer'>
        <img src={InboxPromo} alt='Watch inbox demo' className='zocks-border-0.5 inbox-upsell-promo' />
      </a>
      <div className='d-flex flex-column gap-1'>
        <h5>
          Save hours on emails with <span className='zocks-text-primary'>Inbox</span>
        </h5>
        <div className='paragraph-medium'>Turn your overwhelming inbox into a productivity powerhouse with AI that works exactly how you do.</div>
      </div>
    </>
  )
}

export const InboxUpsellFeatures: React.FC = () => {
  return (
    <>
      <div className='d-flex gap-2'>
        <i className='bi bi-check-lg zocks-text-primary' />
        <div className='paragraph-medium'>
          <strong>Smart Email Categorization</strong>: Automatically categorize emails and get the perfect response template
        </div>
      </div>
      <div className='d-flex gap-2'>
        <i className='bi bi-check-lg zocks-text-primary' />
        <div className='paragraph-medium'>
          <strong>Contextual Intelligence</strong>: Get personalized, compliant drafts with CRM and meeting context
        </div>
      </div>
      <div className='d-flex gap-2 mb-3'>
        <i className='bi bi-check-lg zocks-text-primary' />
        <div className='paragraph-medium'>
          <strong>Automatic client profile updates</strong>: Detect and sync life events and financial changes across your wealth stack
        </div>
      </div>
    </>
  )
}
